module.exports = __webpack_public_path__ + "static/c3-4e4fe999784be4cd94a24ba14c3be4fc.webp";